import { resetModalData, setModalData } from './actionTypes';

export const modalStateReducer = (_state, action) => {
  switch (action.type) {
    case setModalData:
      return action.payload;

    case resetModalData:
      return {};

    default: {
      throw new Error(
        `Данный тип действия не обрабатывается редюсером: ${action.type}`
      );
    }
  }
};
